import type { ListTask } from '../sources';

/**
 * Gets the ID of the next task in the list after the specified task ID
 * @param tasks - Array of list tasks
 * @param currentTaskId - ID of the current task
 * @returns ID of the next task, or null if no next task exists
 */
export const getNextTaskId = (tasks: ListTask[], currentTaskId: string): string | null => {
    const currentIndex = tasks.findIndex((t) => t.id === currentTaskId);
    return currentIndex !== -1 && currentIndex + 1 < tasks.length
        ? tasks[currentIndex + 1].id
        : null;
};

/**
 * Navigates to the next task in the list, or to home if no next task exists
 * @param navigate - React Router navigate function
 * @param tasks - Array of list tasks
 * @param currentTaskId - ID of the current task
 */
export const navigateToNextTask = (
    navigate: (path: string) => void,
    tasks: ListTask[],
    currentTaskId: string,
): void => {
    const nextTaskId = getNextTaskId(tasks, currentTaskId);
    if (nextTaskId) {
        navigate(`/task/${nextTaskId}`);
    } else {
        navigate('/');
    }
};
